import React from 'react'
import '../../styles/_components/_titles/_form_subtitle.scss'

export const FormSubtitle = ({text, _className=""}) => {
    return(
        <h2 className={`c-form_subtitle ${_className}`}>{text}</h2>
    )
}